import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'
import { CaseDownloadCTAItem } from 'components/cases/common/CaseDownloadCTA'

// ファーストビュー
export const firstViewItem = {
  breadcrumb: 'クラウドネイティブなシステム構築と日本向けUX/UI設計でアプリのローカライズを支援',
  title1: 'クラウドネイティブなシステム構築と日本向けUX/UI設計でアプリのローカライズを支援',
  introduction_text:
    'ドイツ/EUで稼働しているアプリケーションを日本市場向けにローカライズするプロジェクトを実施しました。このプロジェクトは、既存機能を引き継ぎつつ、日本向けに「Tennis-Pointアプリ」の個別コンテンツを引き立たせる工夫を行いました。弊社は、AWSのインフラ基盤をヨーロッパから東京リージョンへの移行や、保守性の高いシステム基盤を実現しました。',
  company: 'イオン・シグナ・スポーツ・ユナイテッド株式会社',
  tag1text: 'アプリケーション開発',
  tag1src: '/cases/application-development/',
  tag2text: 'クラウドネイティブ',
  tag2src: '/cases/cloudnative/',
  industryTagText: 'IT/情報/通信',
  industryTagSrc: '/cases/telecommunications/',
  color: '#222',
  background: '#FFEA00',
  staff1: 'イオン・シグナ・スポーツ・ユナイテッド株式会社　マネージャー 眞田 智和さん',
  staff2: '',
  image: '/images/img/cases/tennispointapp/top.png',
  alt: 'クラウドネイティブなシステム構築と日本向けUX/UI設計でアプリのローカライズを支援',
  imgClass: 'fv_img_adjust2',
}

// プロジェクト概要
export const overviewTitle = 'クラウドネイティブで保守性も高いアプリのローカライズをご支援'
export const overviewItem: OverviewItems[] = [
  {
    text: 'イオン株式会社とSIGNA Sports UnitedGmbH（ドイツ）の共同出資にてスタートした同社は、デジタルプラットフォームでスポーツコミュニティの活性化に取り組み、地域スポーツの振興とみなさまの健康増進のベストパートナーを目指す企業です。',
  },
  {
    text: 'ドイツ/欧州連合(EU)で稼働するWebサイトとアプリをローカライズ(日本市場向けに改変)するプロジェクトを弊社にて対応させていただきました。既存の機能を引き継ぎつつ、日本向けにサービス自体が持つイメージを最大化させ、ローカライズした「Tennis-Pointアプリ」の持つ個別コンテンツが引き立たつように工夫しました。また、PCやタブレット、スマートフォンなどさまざまなプラットフォームに応じて、文字の組み方やグラフィックの見せ方を最適化し、日本のユーザーがストレスを感じない表示にすることにも注力しました。ローカライズにあたっては、システムをAWS上に構築しなおし、認証基盤についても独自実装からSalesforceへ移行させるなど、お客様(イオン・シグナ・スポーツ・ユナイテッド株式会社様)にとって保守性の高いシステム基盤を実現することを考慮して構築致しました。',
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: 'ローカライズの必要性',
        text: 'ドイツ/欧州連合のアプリを日本市場向けに適応する必要があり、文化的・言語的な違いに対応するための調整が必要だった。',
      },
      {
        title: 'データベースの利用制限',
        text: '本国版のデータベースが日本でそのまま使えないという問題があり、新たなデータの持ち方や連携方法を構築する必要があった。',
      },
      {
        title: 'セキュリティと基盤の構築',
        text: '日本版はAWSのクラウド基盤を用いて構築する必要があり、イオングループ基準のセキュリティ要件に適合するシステムを構築する必要があった。',
      },
    ],
    solutions: [
      {
        title: '多言語対応と文化適応',
        text: '日本市場向けにサービスを最大化するため、ローカライズ作業を行い、PCやモバイルデバイスでの表示最適化に注力し、ユーザーがストレスを感じないデザインを実現した。',
      },
      {
        title: '新しいデータベースの設計',
        text: '既存のデータベースの制約に対応するために、新たにデータベースを構築し、ドイツの開発者と連携して独自のデータ連携方法を確立した。',
      },
      {
        title: 'AWSを活用したセキュアなシステム構築',
        text: ' AWS上にシステムを再構築し、Salesforceを認証基盤として使用することで、保守性が高くセキュリティ基準に適合したシステムを実現した。',
      },
    ],
  },
]

// 資料ダウンロード CTA
export const caseDownloadCTAItem: CaseDownloadCTAItem = {
  title: 'アプリ開発RFP作成のポイント',
  description: 'アプリ開発担当者向けに、失敗しないためのポイントをテンプレート付の1冊にまとめました',
  imageSrc: '/images/img/cases/cta_rfp.webp',
  href: '/download/rfp/',
}

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UI/UXデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
